import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Country, Region, UserAddressService } from '@spartacus/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomValidators } from '../../../../spartacus/custom/shared/utils/validators/custom-validators';
import { RecaptchaService } from '../../../../spartacus/features/recaptcha/recaptcha.service';
import { ICON_TYPE } from '../../../icons/icon.model';
import { WorkWithUs } from './custom-work-with-us.model';
import { CustomWorkWithUsService } from './custom-work-with-us.service';

@Component({
  selector: 'app-custom-work-with-us',
  templateUrl: './custom-work-with-us.component.html',
  standalone: false
})
export class CustomWorkWithUsComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  @ViewChild('frm') frm: ElementRef;

  @Input()
  fullName: string;

  @Input()
  email: string;

  @Input()
  region: string;

  @Input()
  phone: string;

  @Input()
  message: string;

  @Input()
  termsCheck: boolean;

  @Input()
  dataCheck: boolean;

  workWithUs: WorkWithUs;
  regions$: Observable<Region[]>;
  // is_hide = "select-hide";

  protected submitted = new BehaviorSubject<boolean>(false);
  public submitted$ = this.submitted.asObservable();

  workWithUsForm: UntypedFormGroup = this.formBuilder.group({
    fullName: ['', Validators.required],
    email: ['', [Validators.required, CustomValidators.emailValidator]],
    region: ['', Validators.required],
    phone: ['', [Validators.required, CustomValidators.phoneValidator]],
    message: ['', Validators.nullValidator],
    privacyPolicy: [false, Validators.requiredTrue],
    authorizePersonalData: [false, Validators.requiredTrue],
  });

  iconTypes = ICON_TYPE;

  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected workWithUsService: CustomWorkWithUsService,
    protected userAddressService: UserAddressService,
    protected recaptchaService: RecaptchaService,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  ngOnInit(): void {
    this.regions$ = this.userAddressService.getRegions('ES').pipe(
      map((countries: Country[]) => {
        return countries;
      }),
    );
  }

  submitForm(): void {
    this.switchToSubmitted();
    if (this.workWithUsForm.valid) {
      this.recaptchaService.getToken().then(token => {
        if (token) {
          this.subscriptions.add(this.recaptchaService.validateRecaptchaToken(token).subscribe(response => {
            if (response?.status === 200) {
              this.workWithUs = this.workWithUsForm.value;
              this.workWithUsService.subscribeRequest(this.workWithUs, this.frm.nativeElement);
            } else {
              this.recaptchaService.recaptchaError('forms.recaptcha.invalidToken');
            }
          }));
        } else {
          this.recaptchaService.recaptchaError('forms.recaptcha.invalidToken');
        }
      }).catch(() => this.recaptchaService.recaptchaError(null));
    } else {
      this.workWithUsForm.markAllAsTouched();
    }
  }

  switchToSubmitted() {
    this.submitted.next(true);
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.submitted.next(false);
      }, 1500);
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
